interface Title {
	title: string;
}

interface Info {
	info: string;
}

interface Word {
	to: string;
}

interface Message {
  emptyState: {
    noData: {
      title: string;
      message: string;
    };
    unknownAuthor: {
      title: string;
      message: string;
    };
  };
}

interface FilterDataType extends Title, Info {
	observation: Title;
	scenario: Title;
  mapInfoTitle: string;
}

interface VariableLocal extends Title {
	cdd5: string;
	cdd7: string;
	dhi5: string;
	dhi7: string;
	ews: string;
  ewc: string;
	ftd: string;
	hd30: string;
	hd40: string;
	ls: string;
	sdii: string;
	hs: string;
	sd: string;
	pr: string;
	tmean: string;
	tasmax: string;
	tasmin: string;

	cdd5Tooltip: string;
	cdd7Tooltip: string;
	dhi5Tooltip: string;
	dhi7Tooltip: string;
	ewsTooltip: string;
  ewcTooltip: string;
	ftdTooltip: string;
	hd30Tooltip: string;
	hd40Tooltip: string;
	lsTooltip: string;
	sdiiTooltip: string;
	hsTooltip: string;
	sdTooltip: string;
	prTooltip: string;
	tmeanTooltip: string;
	tasmaxTooltip: string;
	tasminTooltip: string;

	cdd5Title: string;
	cdd7Title: string;
	dhi5Title: string;
	dhi7Title: string;
	ewsTitle: string;
  ewcTitle: string;
	ftdTitle: string;
	hd30Title: string;
	hd40Title: string;
	lsTitle: string;
	sdiiTitle: string;
	hsTitle: string;
	sdTitle: string;
	prTitle: string;
	tmeanTitle: string;
	tasmaxTitle: string;
	tasminTitle: string;

  cdd5Description: string;
  cdd7Description: string;
  dhi5Description: string;
  dhi7Description: string;
  ewsDescription: string;
  ewcDescription: string;
  ftdDescription: string;
  hd30Description: string;
  hd40Description: string;
  lsDescription: string;
  sdiiDescription: string;
  hsDescription: string;
  sdDescription: string;
  prDescription: string;
  tmeanDescription: string;
  tasmaxDescription: string;
  tasminDescription: string;
}

interface Scenario extends Title {
  ens: string;
  rcp26: string;
  rcp45: string;
  rcp85: string;
}

interface Period extends Title {
  '1981-2010': string;
  '2011-2040': string;
  '2001-2020': string;
  '2036-2065': string;
  '2071-2100': string;
}

interface Author extends Title {
  boku?: string;
  defaultLabel?: string;
}

interface GridSpacing extends Title {
  '01deg': string;
}

interface GlobalWarmingLevel extends Title {
  '1.5': string;
  '2.0': string;
  '3.0': string;
  '4.0': string;
}

interface Season extends Title {
  'yr': string;
  '01': string;
  '02': string;
  '03': string;
  '04': string;
  '05': string;
  '06': string;
  '07': string;
  '08': string;
  '09': string;
  '10': string;
  '11': string;
  '12': string;
}

interface FiltersLocal {
  author: Author;
	dataType: FilterDataType;
	variable: VariableLocal;
	period: Period;
  gwl: GlobalWarmingLevel;
	season: Season;
  scenario: Scenario;
  gridSpacing: GridSpacing;
}

interface DownloadOptions {
	image: string;
	pdf: string;
	file: string;
}

interface Options {
	download: DownloadOptions;
}

interface Legend {
	min: string;
	max: string;
}

interface MapDetails {
	value: string;
	ens: string;
	ens75: string;
	ens25: string;

  noCsvData: string;
  subgridToggleLabel: string;
  subgridToggleOnInfo: string;
  subgridToggleOffInfo: string;
}

interface MapTour extends Title, Info {
	map: string;

	observation: string;
	projection: string;

	variables: string;
	variablesFilter: string;

	period: string;
	periodFilter: string;

	season: string;
	seasonFilter: string;

	area: string;
	areaFilter: string;
	areaSearch: string;
	areaSearchLonLat: string;

	legend: string;
	zoomIn: string;
	zoomOut: string;
	pin: string;
	download: string;
}

interface Tour {
	closeButton: string;
	backButton: string;
	nextButton: string;
	completeButton: string;
	startButton: string;

	map?: MapTour;
}

interface Unit {
	Celsius: string;
	'%': string;
	mm: string;
  d: string;
  'm s-1': string;
}

interface MapView {
  noneValue: string;
  terrain: string;
  satellite: string;
}

interface MapOptions {
  showClimateData: string;
}

interface Footer {
  kosovoBorderLabel: string;
}

interface Nav {
  map: string;
}

export default class MyLocale implements Title {
	public title: string;

	public filters: FiltersLocal;
	public options: Options;
	public legend: Legend;
	public mapDetails: MapDetails;
	public word: Word;
	public message: Message;
	public tour: Tour;
	public unit: Unit;
  public mapView: MapView;
  public mapOptions: MapOptions;
  public footer: Footer;
  public nav: Nav;

	constructor(obj: MyLocale) {
		this.title = obj.title;

		this.filters = obj.filters;
		this.options = obj.options;
		this.legend = obj.legend;
		this.mapDetails = obj.mapDetails;
		this.word = obj.word;
		this.message = obj.message;
		this.tour = obj.tour;
		this.unit = obj.unit;
		this.mapView = obj.mapView;
		this.mapOptions = obj.mapOptions;
		this.footer = obj.footer;
		this.nav = obj.nav;
	}
}
